import { api } from './index';
// project
export const addProjectTaskAssignment = (projectId, loginId, taskId) => {
  return api.post(`/api/wedding/${projectId}/checklist/logins/${loginId}/items`, {
    assignment_reference: null,
    focus_level: 2,
    login_id: loginId,
    task_id: taskId,
  });
};

export const deleteProjectTaskAssignment = (projectId, loginId, taskId) => {
  return api.post(`/api/wedding/${projectId}/checklist/logins/${loginId}/items/${taskId}?drop`);
};

export const addProjectTaskComment = (projectId, taskId, comment) => {
  return api.post(`/api/wedding/${projectId}/checklist/items/${taskId}/comments`, {
    body: comment,
  });
};

export const deleteProjectTaskComment = (projectId, taskId, commentId) => {
  return api.delete(`/api/wedding/${projectId}/checklist/items/${taskId}/comments/comment/${commentId}`);
};

export const editProjectTaskComment = (projectId, taskId, commentId, comment) => {
  return api.put(`/api/wedding/${projectId}/checklist/items/${taskId}/comments/comment/${commentId}`, {
    body: comment,
  });
};

export const getProjectTaskComments = (projectId, taskId) => {
  return api.get(`/api/wedding/${projectId}/checklist/items/${taskId}/comments`);
};


// general
export const addGeneralTaskAssignment = (loginId, taskId) => {
  return api.post(`/api/tasks/${taskId}`, {
    assignment_reference: null,
    focus_level: 2,
    login_id: loginId,
    task_id: taskId,
  });
};

export const deleteGeneralTaskAssignment = (loginId, taskId) => {
  return api.delete(`/api/tasks/${taskId}/assignments/${loginId}`);
};

export const addGeneralTaskComment = (taskId, comment) => {
  return api.post(`/api/tasks/${taskId}/comments`, {
    body: comment,
  });
};

export const deleteGeneralTaskComment = (taskId, commentId) => {
  return api.delete(`/api/tasks/${taskId}/comments/comment/${commentId}`);
};

export const editGeneralTaskComment = (taskId, commentId, comment) => {
  return api.put(`/api/tasks/${taskId}/comments/comment/${commentId}`, {
    body: comment,
  });
};

export const getGeneralTaskComments = (taskId) => {
  return api.get(`/api/tasks/${taskId}/comments`);
};
